// extracted by mini-css-extract-plugin
export default {"wrapper":"kC-z","viewport":"lC-z","container":"mC-z","slide":"nC-z"};